import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import * as CryptoJS from 'crypto-js';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PhrutillsService {
  encryptSecretKey : any;
  encryptSecretKeyServices : any;

  private titleSubject = new BehaviorSubject<string>('Breeze Check-in');
  title$ = this.titleSubject.asObservable();
  private defaultLang = new BehaviorSubject<string>('en');
  language$ = this.defaultLang.asObservable();
  private patientLang = new BehaviorSubject<string>('en');
  patientlanguage$ = this.patientLang.asObservable();
  private navbarLastName = new BehaviorSubject<string>('');
  lastName = this.navbarLastName.asObservable();
  private navbarPracName = new BehaviorSubject<string>('');
  pracName = this.navbarPracName.asObservable();
  private amountSource = new BehaviorSubject<string>("");
  amount$ = this.amountSource.asObservable();


  constructor(private toastr: ToastrService, private sanitizer: DomSanitizer) { 
    this.encryptSecretKey = 'asdkbjasd54654asdjabsdjavsd45';
    this.encryptSecretKeyServices ='2595874569321569';
  }
  updateAmount(amount: any) {
    this.amountSource.next(amount);
  }

  setTitle(title: string) {
    this.titleSubject.next(title);
  }
  setdeafultLanguage(lang: string) {
    this.defaultLang.next(lang);
  }
  setPatientLanguage(lang: string) {
    this.patientLang.next(lang);
  }
  setNavbarLastName(value: any) {
    this.navbarLastName.next(value);
  }
  setNavpracName(value: any) {
    this.navbarPracName.next(value);
  }

  showSuccess(message: any, heading: any="") {
    this.toastr.success(message, heading, {
      positionClass: 'toast-top-right',
      timeOut:5000
    });
  }
  showError(message: any, heading: any="") {
    this.toastr.error(message, heading, {
      timeOut: 5000,
      positionClass: 'toast-top-right'
    });
  }
  showWarning(message: any, heading: any="") {
    this.toastr.warning(message, heading, {
      timeOut: 5000,
      positionClass: 'toast-top-right'
    });
  }
  showInfo(message: any, heading: any="") {
    this.toastr.info(message, heading, {
      timeOut: 5000,
      positionClass: 'toast-top-right'
    });
  }
  //------ with cross button and no time out

  showSuccessClose(message: any, heading: any) {
    this.toastr.success(message, heading, {
      closeButton: true,
      extendedTimeOut: 0,
      positionClass: 'toast-top-right'
    });
  }
  showErrorClose(message: any, heading: any) {
    this.toastr.error(message, heading, {
      closeButton: true,
      extendedTimeOut: 0,
      positionClass: 'toast-top-right'
    });
  }
  showWarningClose(message: any, heading: any) {
    this.toastr.warning(message, heading, {
      closeButton: true,
      extendedTimeOut: 0,
      positionClass: 'toast-top-right'
    });
  }
  showInfoClose(message: any, heading: any) {
    this.toastr.info(message, heading, {
      closeButton: true,
      extendedTimeOut: 0,
      positionClass: 'toast-top-right'
    });
  }
  encrypt(data : any) {
    return CryptoJS.AES.encrypt(JSON.stringify(data), this.encryptSecretKey,
      {
        keySize: 128 / 8,
        iv: this.encryptSecretKey,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }).toString();
  }

  decrypt(data : any) {
    return JSON.parse(CryptoJS.enc.Utf8.stringify(CryptoJS.AES.decrypt(data, this.encryptSecretKey,
      {
        keySize: 128 / 8,
        iv: this.encryptSecretKey,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      })));
  }

  encryptforServices(data: any) {

    var key = CryptoJS.enc.Utf8.parse(this.encryptSecretKeyServices);                             // Convert into WordArray (using Utf8)
    var iv = CryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);

    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(data), key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();

  }

  decryptforServices(data : any) {
    var key = CryptoJS.enc.Utf8.parse(this.encryptSecretKeyServices);                             // Convert into WordArray (using Utf8)
    var iv = CryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);   // Use zero vector as IV
    var decrypted = CryptoJS.AES.decrypt(data, key, {iv: iv}); // By default: CBC, PKCS7 
    return decrypted.toString(CryptoJS.enc.Utf8); 
  }

  onTrackError(functionName: string, componentName: string, error: any) {
    console.log(`Error Occured => [ ${componentName} : Component | ${functionName} : Function | Error : ${error} ]`);
  }
  onlyCharacters(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only characters
    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  keyPressNumbers(event:any) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  maskingPhoneNumer(phoneNumDigits : any){

    var formattedNumber = phoneNumDigits;
    if (phoneNumDigits.length >= 6)
      formattedNumber = '(' + phoneNumDigits.substring(0, 3) + ') ' + phoneNumDigits.substring(3, 6) + '-' + phoneNumDigits.substring(6);
    else if (phoneNumDigits.length >= 3)
      formattedNumber = '(' + phoneNumDigits.substring(0, 3) + ') ' + phoneNumDigits.substring(3);
      return formattedNumber;
  }
  maskingZipNum(ZipNumDigits : any)
  {
    var formattedNumber = ZipNumDigits;
    if (ZipNumDigits.length >= 6)
      formattedNumber = ZipNumDigits.substring(0, 5) + '-' + ZipNumDigits.substring(5, 9);
      return formattedNumber;
  }

  genUrl: SafeResourceUrl = "";
  pdfURL(path: string) {
      let replaceDoubleSlash = path.replace(/\\\\/g, "\\");
      let orginalServerPath = replaceDoubleSlash.replace(/\\/g, "/");      
      let serverName = "assets";
      let serverIp = orginalServerPath.split('/');

      if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(serverIp[1]))
      {
        orginalServerPath = orginalServerPath.replace("/" + serverIp[1], serverName);
        path = orginalServerPath;
      }
      else
      {
        orginalServerPath = serverName+'/'+orginalServerPath;
        path = orginalServerPath;
      }
      return this.genUrl = this.sanitizer.bypassSecurityTrustResourceUrl(path);
  }

  CheckDateLessThenCurretDateGlobal(selectdDate: any){
    let cDate = new Date();
    let d: Date = new Date(selectdDate);
    if (d > cDate) {
     return true;
    } else {
     return false;
    }
  }
   //replace min date limit 1970 with 1901 
  CheckValidDateAndSetDefaultDateGlobal(selectedDate: any){
    if (selectedDate) {
      let date =  selectedDate.split('-');
      if(Number(date[0]) < 1901){
        date[0] = '1901';
      }
      return date[0]+'-'+date[1]+'-'+date[2];
    }
    return '';
  }
}
